"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from "react";
import { useClickAway, useKeyPressEvent } from "react-use";
import { NFTSearchResult } from "@/components/header/header-search/HeaderSearchModalItem";
import GroupCreateNftSearchItems from "./GroupCreateNftSearchItems";
import { ApiGroupOwnsNft } from "@/generated/models/ApiGroupOwnsNft";
export default function GroupCreateNftSearch(t0) {
  const $ = _c(21);
  const {
    selected,
    onSelect
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = newV => {
      if (newV) {
        setIsOpen(true);
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onFocusChange = t1;
  const [searchCriteria, setSearchCriteria] = useState(null);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = newV_0 => {
      setSearchCriteria(newV_0);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const onSearchCriteriaChange = t2;
  const wrapperRef = useRef(null);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(false);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useClickAway(wrapperRef, t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpen(false);
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  useKeyPressEvent("Escape", t4);
  let t5;
  if ($[4] !== onSelect) {
    t5 = item => {
      setIsOpen(false);
      setSearchCriteria(null);
      onSelect(item);
    };
    $[4] = onSelect;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const onNftSelect = t5;
  const t6 = searchCriteria ?? "";
  let t7;
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e => onSearchCriteriaChange(e.target.value);
    t8 = () => onFocusChange(true);
    t9 = () => onFocusChange(false);
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
  } else {
    t7 = $[6];
    t8 = $[7];
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t6) {
    t10 = <input type="text" value={t6} onChange={t7} onFocus={t8} onBlur={t9} id="group-create-nft-search" className={"tw-form-input tw-block tw-pb-3 tw-pt-3 tw-pl-10 tw-pr-4 tw-w-full tw-text-md tw-rounded-lg tw-border-0 tw-appearance-none tw-text-white tw-border-iron-700 focus:tw-border-blue-500 tw-peer\n tw-bg-iron-900 focus:tw-bg-iron-900 tw-font-medium tw-caret-primary-300 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 hover:tw-ring-iron-650 placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out"} placeholder=" " />;
    $[9] = t6;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  let t12;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <svg className="tw-pointer-events-none tw-absolute tw-left-3 tw-top-3.5 tw-h-5 tw-w-5 tw-text-iron-300" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clipRule="evenodd" /></svg>;
    t12 = <label htmlFor="group-create-nft-search" className={"tw-absolute tw-rounded-lg tw-cursor-text tw-text-md tw-font-medium tw-text-iron-500 tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-top-2 tw-z-10 tw-origin-[0] tw-bg-iron-900  peer-focus:tw-bg-iron-900 tw-ml-7 tw-px-2 peer-focus:tw-px-2 peer-focus:tw-text-primary-400 peer-placeholder-shown:tw-scale-100 \n                    peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-top-1/2 peer-focus:tw-top-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 rtl:peer-focus:tw-translate-x-1/4 rtl:peer-focus:tw-left-auto tw-start-1"}>NFT</label>;
    $[11] = t11;
    $[12] = t12;
  } else {
    t11 = $[11];
    t12 = $[12];
  }
  let t13;
  if ($[13] !== isOpen || $[14] !== onNftSelect || $[15] !== searchCriteria || $[16] !== selected) {
    t13 = <GroupCreateNftSearchItems open={isOpen} searchCriteria={searchCriteria} selected={selected} onSelect={onNftSelect} />;
    $[13] = isOpen;
    $[14] = onNftSelect;
    $[15] = searchCriteria;
    $[16] = selected;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t10 || $[19] !== t13) {
    t14 = <div className="tw-group tw-w-full tw-relative" ref={wrapperRef}>{t10}{t11}{t12}{t13}</div>;
    $[18] = t10;
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  return t14;
}